import React, { useState } from "react";

export default function ClarifyThread({ threads = [], onAdd, fieldKey }) {
  const [note, setNote] = useState("");
  return (
    <div className="mt-2 rounded-lg border border-gray-200 bg-gray-50 p-3">
      <div className="text-xs font-semibold text-gray-600">ClarifyBot</div>
      <ul className="mt-2 space-y-2">
        {threads.map((t, idx) => (
          <li key={idx} className="rounded-md bg-white p-2 shadow-sm ring-1 ring-gray-200">
            <div className="text-xs text-gray-500">{t.when}</div>
            <div className="text-sm">{t.text}</div>
          </li>
        ))}
      </ul>
      <div className="mt-2 flex gap-2">
        <input
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder="Request an update or add a note…"
          className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
        <button
          type="button"
          onClick={() => {
            if (!note.trim()) return;
            onAdd?.(fieldKey, note.trim());
            setNote("");
          }}
          className="rounded-md bg-blue-600 px-3 py-2 text-sm font-medium text-white hover:bg-blue-700"
        >
          Request Update
        </button>
      </div>
    </div>
  );
}
